import { render, staticRenderFns } from "./DevisKanban.vue?vue&type=template&id=16f3b11d&scoped=true"
import script from "./DevisKanban.vue?vue&type=script&lang=js"
export * from "./DevisKanban.vue?vue&type=script&lang=js"
import style0 from "./DevisKanban.vue?vue&type=style&index=0&id=16f3b11d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3b11d",
  null
  
)

export default component.exports